import { Field, FieldProps } from 'formik'
import RadioGroup from 'antd/lib/radio/group'

type RadioGroupProps = {
  name: string
  children: React.ReactNode
} & { [key: string]: unknown }

export const FormikRadioGroup = ({ name, children, onChange, ...restProps }: RadioGroupProps): JSX.Element => {
  return (
    <Field name={name}>
      {({ field: { value }, form: { setFieldValue } }: FieldProps) => (
        <RadioGroup
          name={name}
          value={value}
          onChange={(e) => {
            const v = e.target.value
            setFieldValue(name, v, true)
          }}
          {...restProps}
        >
          {children}
        </RadioGroup>
      )}
    </Field>
  )
}
